module.exports = __webpack_public_path__ + "static/mary-kay-6-fd17e113b9443637118c4005e794ec13.jpg";